import React from 'react';
import { BadgeCheckIcon, CalendarCheckIcon, HomeIcon, ShieldCheckIcon } from 'lucide-react';
const items = [{
  icon: BadgeCheckIcon,
  label: 'NV Licensed Contractor #0093347'
}, {
  icon: HomeIcon,
  label: 'Local & family-owned'
}, {
  icon: CalendarCheckIcon,
  label: 'Same-week scheduling'
}, {
  icon: ShieldCheckIcon,
  label: 'Quality guaranteed'
}];
export function TrustStrip() {
  return <section aria-label="Why homeowners choose us" className="bg-brand" data-id="element-319" data-mp="2acxl9o88tyoi">
      <ul className="mx-auto grid max-w-7xl grid-cols-2 gap-x-6 gap-y-3 px-5 py-5 lg:flex lg:justify-between lg:px-8" data-id="element-320" data-mp="25db5b71164c0">
        {items.map(({
        icon: Icon,
        label
      }) => <li key={label} className="flex items-center gap-2.5 text-white" data-id="element-321" data-mp="20ei4of6ue7t9">
            <Icon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-322" data-mp="1wdy6r9eg3062" />
            <span className="font-display text-base font-semibold sm:text-lg" data-id="element-323" data-mp="3usreuniv9s2f">{label}</span>
          </li>)}
      </ul>
    </section>;
}